import type { Banner } from "@/types";

export const bannerList: Banner[] = [
  {
    id: "banner-1",
    title: "星海启航",
    subtitle: "跟随古老星图，驶向宇宙尽头的神秘文明",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20scene%20of%20a%20starship%20sailing%20through%20a%20vast%20orange%20and%20teal%20space%20nebula%20with%20glowing%20stars%2C%20dramatic%20lighting%2C%20modern%20anime%20illustration%2C%20high%20detail&width=1400&height=600&seq=hero-banner-01&orientation=landscape",
    linkType: "detail",
    linkId: "anime-1",
    tag: "重磅新番",
  },
  {
    id: "banner-2",
    title: "时空旅人",
    subtitle: "每次回到过去，都会失去一段关于你的记忆",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20scene%20of%20a%20boy%20surrounded%20by%20floating%20glowing%20clock%20fragments%20and%20time%20portals%2C%20teal%20and%20orange%20glow%2C%20modern%20anime%20illustration%2C%20high%20detail&width=1400&height=600&seq=hero-banner-02&orientation=landscape",
    linkType: "detail",
    linkId: "anime-5",
    tag: "口碑佳作",
  },
  {
    id: "banner-3",
    title: "治愈时刻专题",
    subtitle: "深夜想看的温柔故事，陪你安静坐一会儿",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20warm%20anime%20scene%20of%20a%20cozy%20bakery%20and%20tea%20by%20a%20window%20at%20night%2C%20soft%20peach%20orange%20glow%2C%20modern%20anime%20illustration%2C%20high%20detail&width=1400&height=600&seq=hero-banner-03&orientation=landscape",
    linkType: "special",
    linkId: "special-3",
    tag: "编辑专题",
  },
  {
    id: "banner-4",
    title: "苍穹之翼",
    subtitle: "最后一代苍穹骑士，展开守护天空之城的羽翼",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20fantasy%20anime%20scene%20of%20a%20winged%20knight%20soaring%20above%20floating%20islands%20at%20sunset%2C%20warm%20orange%20sky%2C%20modern%20anime%20illustration%2C%20high%20detail&width=1400&height=600&seq=hero-banner-04&orientation=landscape",
    linkType: "detail",
    linkId: "anime-2",
    tag: "本季完结",
  },
];